export default {
  actions: {},
  getters: {
    filterByAttributeValue: state => (attribute, value) => {
      if (!attribute) {
        return [];
      }

      return state.list.filter(item => {
        if (item[attribute] === undefined) {
          return false;
        }

        return item[attribute] === value;
      });
    },
    getById: state => findId => {
      return state.list.find(item => {
        return item.id === findId;
      });
    },
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    setRecord(state, record) {
      state.record = record;
    },
  },
  namespaced: true,
  state: {
    list: [
      {
        name: "Analytics",
        itemType: "single",
      },
      {
        name: "Bridges",
        itemType: "single",
      },
      {
        name: "Cadence",
        itemType: "multiple",
      },
      {
        name: "Care Everywhere",
        itemType: "single",
      },
      {
        name: "Epiccare",
        itemType: "single",
      },
      {
        name: "Identity",
        itemType: "single",
      },
      {
        name: "In Basket",
        itemType: "single",
      },
      {
        name: "Infection and Isolation",
        itemType: "multiple",
      },
      {
        name: "MyChart",
        itemType: "single",
      },
      {
        name: "Prelude",
        itemType: "single",
      },
      {
        name: "Professional Billing",
        itemType: "multiple",
      },
      {
        name: "Radar",
        itemType: "single",
      },
      {
        name: "Reporting Workbench",
        itemType: "single",
      },
      {
        name: "Release of Info",
        itemType: "single",
      },
      {
        name: "Referral",
        itemType: "single",
      },
      {
        name: "Shared",
        itemType: "single",
      },
      {
        name: "Web Suite",
        itemType: "single",
      },
      {
        name: "Willow",
        itemType: "single",
      },
    ],
    record: null,
  },
};
